import m from "./index.es226.js";
import i from "./index.es227.js";
import v from "./index.es99.js";
const C = (t, e, n = 3) => {
  let a = 0;
  const p = m(50, 250);
  return i((l) => {
    const r = l.loaded, o = l.lengthComputable ? l.total : void 0, s = r - a, d = p(s), u = r <= o;
    a = r;
    const c = {
      loaded: r,
      total: o,
      progress: o ? r / o : void 0,
      bytes: s,
      rate: d || void 0,
      estimated: d && o && u ? (o - r) / d : void 0,
      event: l,
      lengthComputable: o != null,
      [e ? "download" : "upload"]: !0
    };
    t(c);
  }, n);
}, f = (t, e) => {
  const n = t != null;
  return [(a) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: a
  }), e[1]];
}, y = (t) => (...e) => v.asap(() => t(...e));
export {
  y as asyncDecorator,
  f as progressEventDecorator,
  C as progressEventReducer
};
//# sourceMappingURL=index.es176.js.map
